module.exports = __webpack_public_path__ + "img/ico-delivery.a5693be8.svg";